import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {NgbDropdownModule, NgbNavModule, NgbCollapseModule} from '@ng-bootstrap/ng-bootstrap';
import { LandingRoutingModule } from "./landing-routing.module";
import { SharedLandingModule } from './shared/shared-landing.module';
import { RouterModule } from '@angular/router';
import { HomeLandingComponent } from './pages/home/home-landing.component';
import { LanguageService } from '../core/services/language.service';
import { TranslateModule } from '@ngx-translate/core';

import { LandingFooterComponent } from './layout/footer/landing-footer.component';
import { LandingHeaderComponent } from './layout/header/landing-header.component';
import { HomeSectionOneComponent } from './pages/home-section1/home-section1.component';
import { HomeSectionTwoComponent } from './pages/home-section2/home-section2.component';
import { ContactComponent } from './pages/contact/contact.component';
import { SimplebarAngularModule } from 'simplebar-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingBarModule } from '../core/loading-bar/loading-bar.module';
import { LandingLayoutComponent } from './layout/landingpage/landing-layout.component';
import { InstitutionComponent } from './layout/institutionpage/institution.component';
import { TeacherComponent } from './layout/teacherpage/teacher.component';
import { StudentComponent } from './layout/studentpage/student.component';
import { ParentComponent } from './layout/parentpage/parent.component';
import {ContactPageComponent } from './layout/contactpage/contactpage.component';
import { AboutPageComponent } from './layout/aboutpage/aboutpage.component';
import { ReplacePipe } from '../dashboard/services/replace';
import { SafeHtmlPipe } from '../dashboard/services/safe.html';
import { PrivacyPageComponent } from './layout/privacypage/privacypage.component';
import { TermsPageComponent } from './layout/termspage/termspage.component';
import { RoleModalComponent } from './layout/role-modal/role-modal.component';


@NgModule({
  declarations: [ 
    LandingLayoutComponent,
    LandingFooterComponent,
    LandingHeaderComponent,
    HomeLandingComponent,
    HomeSectionOneComponent,
    HomeSectionTwoComponent,    
    ContactComponent,
    InstitutionComponent,
    TeacherComponent,
    StudentComponent,
    ParentComponent,
    ContactPageComponent,
    PrivacyPageComponent,
    TermsPageComponent,
    RoleModalComponent,
    AboutPageComponent

  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbCollapseModule,
    NgbDropdownModule,
    NgbNavModule,
    SimplebarAngularModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    LoadingBarModule,
    SharedLandingModule,
    LandingRoutingModule,
    ReplacePipe,
    SafeHtmlPipe
  ],

  exports: [

  ],
  providers: [LanguageService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LandingModule { }
